export const externalApiActions = [
  {
    name: 'sendDataToExternalApi',
    label: 'Send Data To External API',
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsExternalApi',
        value: '',
      },
      {
        name: 'sessionValue',
        label: 'Send Session Response Value (comma separated)',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionFormValue',
        label: 'Send Session Form Value (comma separated)',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'overrideBrowserSessionValuesKey',
        label: 'Override Each Record JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overrideBrowserSessionFormDataValuesKey',
        label: 'Override Each Record JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overrideResponseDataKey',
        label: 'Save API Response In Custom JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overrideFormDataKey',
        label: 'Save API Response In Custom JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overriddenCustomJsonKey',
        label: 'Custom JSON Key',
        type: 'text',
        value: '',
      },
      {
        name: 'overriddenFormCustomJsonKey',
        label: 'Custom JSON Key',
        type: 'text',
        value: '',
      },
      {
        name: 'sendPreviousActionResponseItemId',
        label: 'Send Item Id of previous action response',
        type: 'boolean',
        value: '',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
      // Commented the properties below related to console log arguments
      // {
      //   name: 'enableConsoleLogArgs',
      //   label: 'Enable Console Log Arguments',
      //   type: 'boolean',
      //   value: '',
      // },
      // {
      //   name: 'startConsoleLogArgs',
      //   label: '(Optional) Entry console log argument list (comma [,] separated)',
      //   type: 'text',
      //   value: '',
      // },
      // {
      //   name: 'endConsoleLogArgs',
      //   label: '(Optional) Exit console log argument list (comma [,] separated)',
      //   type: 'text',
      //   value: '',
      // },
    ],
  },
  {
    name: 'sendDataToExternalApiAndAuthorize',
    label: 'Authorize Using External API',
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsExternalApi',
        value: '',
      },
      {
        name: 'userRole',
        label: 'Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        value: '',
      },
      {
        name: 'sessionValue',
        label: 'Send Session Value (comma separated)',
        type: 'text',
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
  {
    name: 'sendDataToExternalApiAndFileDownload',
    label: 'Download File Using External API',
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsExternalApi',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
  {
    name: 'triggerZap',
    label: 'Zapier - Trigger a Zap',
    args: [
      {
        name: 'webhookId',
        label: 'Zaps',
        type: 'dropdown',
        optionsType: 'dsZaps',
        value: '',
      },
      {
        name: 'sessionValue',
        label: 'Send Session Value (comma separated)',
        type: 'text',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
];
